var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.5V2.5H6.2577C6.32052 1.94488 6.56282 1.47278 6.9846 1.08368C7.4064 0.69456 7.91313 0.5 8.50478 0.5C9.09644 0.5 9.60317 0.69456 10.025 1.08368C10.4468 1.47278 10.6859 1.94488 10.7423 2.5H17V19.5H0ZM1.49997 18H15.5V3.99998H1.49997V18ZM3.75 15.6346H10.25V14.1346H3.75V15.6346ZM3.75 11.75H13.25V10.25H3.75V11.75ZM3.75 7.86535H13.25V6.36538H3.75V7.86535ZM8.49998 3.34613C8.71664 3.34613 8.89581 3.27529 9.03748 3.13363C9.17914 2.99196 9.24998 2.81279 9.24998 2.59613C9.24998 2.37946 9.17914 2.20029 9.03748 2.05863C8.89581 1.91696 8.71664 1.84613 8.49998 1.84613C8.28331 1.84613 8.10414 1.91696 7.96248 2.05863C7.82081 2.20029 7.74998 2.37946 7.74998 2.59613C7.74998 2.81279 7.82081 2.99196 7.96248 3.13363C8.10414 3.27529 8.28331 3.34613 8.49998 3.34613Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignment);
export default __webpack_public_path__ + "static/media/assignment.3b8c7c72ef57f10cf39c69b35e347b93.svg";
export { ForwardRef as ReactComponent };